/* eslint-disable @typescript-eslint/no-explicit-any */
import React from "react";
import { View, Page } from "@react-pdf/renderer";
import ArtifiPdfPage from "./ArtifiPdfPage";
import RawlingsGlovesPdfPage from "./RawlingsGlovesPdfPage";
import EastonGlovesPdfPage from "./EastonGlovesPdfPage";
import HelmetPdfPage from "./HelmetPdfPage";
import styles from "./styles";
import WoodBatPdfPage from "./WoodBatPdfPage";

const DataTree = ({ productDetails }: any) => {
  let htmlData: any = [];

  if (productDetails?.artifi.length > 0) {
    htmlData = [...htmlData, ...ArtifiPdfPage(productDetails?.artifi)];
  }

  if (productDetails?.rawlingsGlove.length > 0) {
    htmlData = [...htmlData, ...RawlingsGlovesPdfPage(productDetails?.rawlingsGlove)];
  }

  if (productDetails?.eastonGloves.length > 0) {
    htmlData = [...htmlData, ...EastonGlovesPdfPage(productDetails?.eastonGloves)];
  }

  if (productDetails?.helmet.length > 0) {
    htmlData = [...htmlData, ...HelmetPdfPage(productDetails?.helmet)];
  }

  if (productDetails?.eastonHelmet.length > 0) {
    htmlData = [...htmlData, ...HelmetPdfPage(productDetails?.eastonHelmet)];
  }

  if (productDetails?.woodBat.length > 0) {
    htmlData = [...htmlData, ...WoodBatPdfPage(productDetails?.woodBat)];
  }

  const result = [];
  for (let i = 0; i < htmlData.length; i += 52) {
    result.push(htmlData.slice(i, i + 52));
  }

  const resultPro = [];
  for (let i = 0; i < result.length; i += 2) {
    resultPro.push(result.slice(i, i + 2));
  }

  return (
    <>
      {resultPro &&
        resultPro.map((column: any, containerIndex: number) => {
          return (
            <Page
              wrap
              size="A4"
              style={styles.page}
              orientation="portrait"
              key={`container=${containerIndex}`}
            >
              <View style={styles.wrapper}>
                {column &&
                  column.map((columnData: any, columnIndex: number) => (
                    <View style={styles.column} key={columnIndex}>
                      {columnData && columnData.map((data: any) => data)}
                    </View>
                  ))}
              </View>
            </Page>
          );
        })}
    </>
  );
};

export default DataTree;
